var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26788 6.74997H21.75C22.0815 6.74997 22.3995 6.88167 22.6339 7.11609C22.8683 7.35051 23 7.66845 23 7.99997C23 8.33149 22.8683 8.64943 22.6339 8.88385C22.3995 9.11828 22.0815 9.24997 21.75 9.24997H5.26788L9.1345 13.1154L9.13455 13.1154C9.36915 13.35 9.50095 13.6682 9.50095 14C9.50095 14.3317 9.36915 14.6499 9.13455 14.8845C8.89995 15.1191 8.58177 15.2509 8.25 15.2509C7.91823 15.2509 7.60005 15.1191 7.36545 14.8845L1.36589 8.88497C1.24949 8.76886 1.15713 8.63091 1.09411 8.47905C1.0311 8.32719 0.998659 8.16439 0.998659 7.99997C0.998659 7.83555 1.0311 7.67275 1.09411 7.52089C1.15713 7.36903 1.24949 7.23108 1.36589 7.11497L7.36545 1.11542L7.71656 1.46653L7.36545 1.11542C7.60005 0.880819 7.91823 0.749023 8.25 0.749023C8.58177 0.749023 8.89995 0.880819 9.13455 1.11542C9.36915 1.35002 9.50095 1.6682 9.50095 1.99997C9.50095 2.33174 9.36915 2.64993 9.13455 2.88452L9.1345 2.88458L5.26788 6.74997Z",
    fill: "#333333",
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrow);
export default __webpack_public_path__ + "static/media/blackArrow.dd27220d5780c09068514af7d263dff8.svg";
export { ForwardRef as ReactComponent };